// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBq1BcUnru90qSJ84CVxzFIxUVfZDXNMZY",
  authDomain: "ks-expense-manager.firebaseapp.com",
  projectId: "ks-expense-manager",
  storageBucket: "ks-expense-manager.appspot.com",
  messagingSenderId: "813689299322",
  appId: "1:813689299322:web:1b12f753074223da6f36c3",
  measurementId: "G-P4CGVZ4C7Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);